import RecommendationTeaserContext, {
  RecommendationTeaserContextType,
} from '@contexts/recommendationTeaser'
import { useContext } from 'react'

const useIsRecommendationTeaser = (): RecommendationTeaserContextType =>
  useContext(RecommendationTeaserContext)

export default useIsRecommendationTeaser
